// Sugalarm — /api/reminders wrappers (cycle 76).

import { request } from "../lib/apiClient";
import type {
  ApiResult,
  Reminder,
  ReminderCreateIn,
  ReminderUpdateIn,
} from "../lib/types";

export function list(): Promise<ApiResult<Reminder[]>> {
  return request<Reminder[]>("/api/reminders");
}

export function create(body: ReminderCreateIn): Promise<ApiResult<Reminder>> {
  return request<Reminder>("/api/reminders", { method: "POST", body });
}

export function update(
  id: string,
  body: ReminderUpdateIn,
): Promise<ApiResult<Reminder>> {
  return request<Reminder>(`/api/reminders/${id}`, { method: "PATCH", body });
}

export function remove(id: string): Promise<ApiResult<void>> {
  return request<void>(`/api/reminders/${id}`, { method: "DELETE" });
}

// Fire the reminder right now via the real delivery path (WS + push),
// ignoring schedule/enabled and WITHOUT consuming today's occurrence.
export function test(id: string): Promise<ApiResult<Reminder>> {
  return request<Reminder>(`/api/reminders/${id}/test`, { method: "POST" });
}

// Cycle 272: snoozing a FIRED reminder fans out to the owner's other
// devices. Returns the absolute `snooze_until_ms` so every device re-shows
// the overlay together.
export function snooze(
  id: string,
): Promise<ApiResult<{ snooze_until_ms: number }>> {
  return request<{ snooze_until_ms: number }>(
    `/api/reminders/${id}/snooze`,
    { method: "POST" },
  );
}

// Cycle 272: marking a FIRED reminder Done fans out so it clears everywhere.
export function dismiss(id: string): Promise<ApiResult<void>> {
  return request<void>(`/api/reminders/${id}/dismiss`, { method: "POST" });
}

// Cycle 362: acknowledge a specific fired OCCURRENCE. This is the DURABLE
// Close — it stamps `reminder_fires.dismissed_at` server-side, so the
// acknowledgement survives a reload, a reboot, and a device that was offline
// when the cross-device broadcast went out. Prefer this over `dismiss(id)`
// whenever the fired reminder carried a `fire` (everything except a `/test`
// fire, which creates no durable obligation).
export function dismissFire(fireId: string): Promise<ApiResult<void>> {
  return request<void>(`/api/reminders/fires/${fireId}/dismiss`, {
    method: "POST",
  });
}
